/**
 * Ajudantes de DOM.
 *
 * Não é um framework e não deve virar um. São vinte linhas que evitam a
 * repetição de `createElement` + `className` + `appendChild` em cada tela;
 * quando isto começar a crescer, o sinal é que faltava um framework de
 * verdade, não mais funções aqui.
 */

type Filho = Node | string | null | undefined | false;

export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs: Record<string, string | boolean | ((e: Event) => void)> = {},
  ...filhos: Filho[]
): HTMLElementTagNameMap[K] {
  const n = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs)) {
    if (typeof v === "function") n.addEventListener(k.replace(/^on/, ""), v);
    else if (typeof v === "boolean") {
      if (v) n.setAttribute(k, "");
    } else if (k === "class") n.className = v;
    else n.setAttribute(k, v);
  }
  for (const f of filhos) {
    if (f === null || f === undefined || f === false) continue;
    // String vira textNode, NUNCA innerHTML: legenda de post é texto de
    // usuário, e um `<img onerror>` numa legenda não pode virar script.
    n.appendChild(typeof f === "string" ? document.createTextNode(f) : f);
  }
  return n;
}

export function limpar(n: HTMLElement): HTMLElement {
  while (n.firstChild) n.removeChild(n.firstChild);
  return n;
}

/** Data/hora da API (ISO com fuso) no relógio de quem está olhando. */
export function horario(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  });
}

/** Só o dia, para agrupar o calendário. */
export function dia(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("pt-BR", {
    weekday: "short",
    day: "2-digit",
    month: "short"
  });
}

export function bytesLegivel(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
}
